export default __webpack_public_path__ + "static/media/main.6f12edbb.png";